import { Component } from '@angular/core';

@Component({
  selector: 'app-gst',
  templateUrl: './gst.component.html',
  styleUrls: ['./gst.component.css']
})
export class GstComponent {
  ShowCard:any;
}
